export const NAV_BG_COLOR = '#F6F6F6';
